import React, { useEffect, useMemo, useState } from "react";
import { User } from "./UserOverview/User";
import { Row, Typography, Radio, Divider } from "antd";
import { UserRequests } from "./UserOverview/Userrequests";
import { RejectedUsers } from "./UserOverview/RejectedUsers";
import { useSearchParams } from "react-router-dom";

type UserOverviewType = "all-users" | "signup-requests" | "rejected-signups";

const RadioButtonData: { key: UserOverviewType; label: string }[] = [
  {
    key: "all-users",
    label: "All users"
  },
  {
    key: "signup-requests",
    label: "Signup requests"
  },
  {
    key: "rejected-signups",
    label: "Rejected signups"
  }
];

export const UserOverview: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const [tabIndex, setTabIndex] = useState<UserOverviewType>(
    (params.get("tab") as UserOverviewType) ?? "all-users"
  );
  let searchValue = useMemo(() => params.get("search")?.replace(/ /g, "+") ?? "", [params]);

  useEffect(() => {
    setParams((params) => {
      params.set("tab", tabIndex);
      return params;
    });
  }, [tabIndex, setParams]);

  return (
    <div>
      <Row>
        <Typography
          style={{
            fontWeight: 500,
            fontSize: "30px",
            lineHeight: "38px"
          }}>
          User overview
        </Typography>
      </Row>
      <Row>
        <Radio.Group
          style={{ marginBottom: 16, marginTop: 16, display: "flex" }}
          defaultValue={tabIndex}
          value={tabIndex}
          onChange={(e) => {
            setTabIndex(e.target.value);
          }}>
          {RadioButtonData.map((item) => (
            <Radio.Button
              style={{
                color: "#CECFD2",
                fontSize: "14px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              value={item.key}>
              {item.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </Row>
      <Row style={{ marginBottom: "16px" }}>
        <Divider style={{ backgroundColor: "#404040", padding: 0, margin: 0 }} />
      </Row>
      <>
        {tabIndex === "all-users" ? (
          <User />
        ) : tabIndex === "signup-requests" ? (
          <UserRequests search={searchValue} />
        ) : (
          <RejectedUsers />
        )}
      </>
    </div>
  );
};
